import { useEffect, useLayoutEffect } from 'react';
import { isServer } from '../common/isServer.mjs';

const useIsomorphicLayoutEffect = isServer() ? useEffect : useLayoutEffect;

export { useIsomorphicLayoutEffect as default };
//# sourceMappingURL=useIsomorphicLayoutEffect.mjs.map
